
import React from 'react'
import { RequestItemCoPilot } from './requestItemCopilot';
import { EmptyWrapper } from './emptyWrapper';
 
export const Requests = ({team, projectId}) => {

    return ( 
        <div className="requests-component">
              <ul>
              {
                   team?.length>0 && team?.map((item,i)=>(
                     <RequestItemCoPilot key={'requests'+i} item={item} projectId={projectId} />
                   ))
               }
               {team?.length<=0 && (
                    <EmptyWrapper />
                )}
            </ul>
        </div>
    )
}
